import { Pipe, PipeTransform } from '@angular/core';

import { getColor } from '../constants/constants';

@Pipe({ name: 'getColor' })
export class GetColorPipe implements PipeTransform {
  transform(parameter, value) {
    return getColor(parameter, value);
  }
}
